import React, { useRef, useEffect } from 'react';

interface OutsideClickDetectorProps {
    onOutsideClick: () => void
    children: React.ReactNode
}

export const OutsideClickDetector = ({ onOutsideClick, children }: OutsideClickDetectorProps) => {
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
                onOutsideClick()
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        };
    }, [onOutsideClick])

    return <div ref={wrapperRef}>{children}</div>;
};